import { type AvailabilityData } from '~/context/srp/InventoryContext';
import type { AvailabilityVehicle } from '~/contracts/srp';

export const convertAvailabilityVehiclesToMap = (
  availabilityVehicles: AvailabilityVehicle[]
) =>
  availabilityVehicles.reduce<Record<number, AvailabilityData>>((acc, v) => {
    acc[v.vehicleId] = {
      soonestPickup: v.soonestPickup,
      soonestDelivery: v.soonestDelivery
    };

    return acc;
  }, {});
